import { IDropdown } from "@/IDropdown";

export class LanguageInfo implements IDropdown {
  constructor(code: string, name: string) {
    this.code = code;
    this.name = name;
  }
  code: string;
  name: string;

}

export function getTextToSpeechCode(language: LanguageInfo): string {
  switch (language.code) {
    case "he":
      return "iw-IL";
  }
  return language.code;
}